import type { ReactNode } from "react";

import { OndoMark } from "../lib/OndoMark.tsx";
import { TrustedByArtists } from "./TrustedByArtists.tsx";
import { PROMISES } from "./auth.constants.ts";
import "./auth.css";

/**
 * The frame both signed-out screens sit in: hero on the left, a fixed rail on
 * the right, the marquee pinned to the bottom.
 *
 * Extracted when signup arrived rather than duplicated. The hero is around 200
 * lines of layout and four breakpoints' worth of responsive rules; a second
 * copy would drift from this one the first time either changed, and the two
 * screens are meant to be indistinguishable apart from the panel.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <div className="auth__body">
        <section className="auth__hero">
          <img
            className="auth__hero-image"
            src="/main-bg.jpg"
            alt=""
            fetchPriority="high"
          />
          <div className="auth__hero-scrim" />

          <div className="auth__hero-inner">
            <div>
              <span className="auth__mark">
                <OndoMark />
              </span>
              <h1 className="auth__wordmark">Ondo</h1>
              <p className="auth__tagline">
                Authoritative provenance for the art world.
              </p>
            </div>

            <ul className="auth__points">
              {PROMISES.map((promise) => (
                <li className="auth__point" key={promise.icon}>
                  <span className="auth__point-icon" aria-hidden="true">
                    {promise.icon}
                  </span>
                  <span>{promise.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="auth__panel">
          <div className="auth__panel-inner">{children}</div>
        </section>
      </div>

      <TrustedByArtists />
    </div>
  );
}
